package system

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.github.quillraven.fleks.World.Companion.inject
import com.soywiz.korge.box2d.*
import com.soywiz.korge.view.*
import com.soywiz.korma.geom.*
import component.*
import org.jbox2d.common.*
import org.jbox2d.dynamics.*
import org.jbox2d.dynamics.World

class Box2dStepSystem(
    private val physicWorld: World = inject(),
    private val velocityIterations: Int = 6,
    private val positionIterations: Int = 2,
    private val autoDestroyBodies: Boolean = true,
) : IteratingSystem(
    family { all(PlayerComponent) }
) {

    private val tempVec = Vec2()
    private val tempPos = Point()

    override fun onTick() {
        super.onTick()

        physicWorld.step(deltaTime, velocityIterations, positionIterations)
        physicWorld.forEachBody { node ->
            val view = node.view

            if (view != null) {
                val worldScale = physicWorld.customScale
                val worldScaleInv = 1.0 / worldScale

                //val viewPos = view.getPositionRelativeTo(worldView, tempPos)
                val viewPos = tempPos.setTo(view.x, view.y)

                if (viewPos.x != node.viewInfo.x || viewPos.y != node.viewInfo.y || view.rotation != node.viewInfo.rotation) {
                    node.setTransform(
                        tempVec.set(viewPos.x * worldScaleInv, viewPos.y * worldScaleInv),
                        view.rotation
                    )
                    node.linearVelocity = tempVec.set(0f, 0f)
                    node.angularVelocity = 0f
                    node.isActive = true
                    node.isAwake = true
                }

                val newX = node.position.x.toDouble() * worldScale
                val newY = node.position.y.toDouble() * worldScale

                view.position(newX, newY)
                //view.setPositionRelativeTo(worldView, tempPos.setTo(newX, newY))

                view.rotation = node.angle

                val viewRoot = view.root
                val viewRootStage = viewRoot is Stage

                node.viewInfo.x = view.x
                node.viewInfo.y = view.y
                node.viewInfo.rotation = view.rotation

                if (autoDestroyBodies && node.viewInfo.onStage && !viewRootStage) {
                    physicWorld.destroyBody(node)
                    node.view?.body = null
                    node.view = null
                }

                node.viewInfo.onStage = viewRootStage
            }
        }
    }

    // store position before world update for smooth interpolated rendering
    override fun onTickEntity(entity: Entity) {

    }
}
